<template>
  <div class="l-expert">
    <div class="l-expert__loading" v-if="isPending">
      <div class="ws-list-view-skeleton">
        <ws-list-view-skeleton-item
          :height="'30px'"
          :boxCount="1"
          :boxHeights="['30px']"
        />
        <ws-list-view-skeleton-item
          :height="'25px'"
          :boxCount="1"
          :boxHeights="['25px']"
        />
      </div>
    </div>
    <ws-list-view
      v-else-if="experts && experts.length"
      class="ws-members__list"
      :data="experts"
      :header="false"
      :placeholder="''"
      :detailed="false"
      :skeleton="isPending"
    >
      <template slot-scope="props">
        <ws-list-view-item-column>
          <div class="ws-members__item ws-members__item--upt ws-member">
          <div class="ws-member__column">
              <figure class="image is-128x128">
                <ws-avatar
                  v-if="props.row"
                  :id="props.row.guid"
                  :name="getExpertName(props.row)"
                  :size="128"
                />
              </figure>
          </div>
          <div class="ws-member__column">
            <span v-if="props.row">
              <strong>{{ getExpertName(props.row) }}</strong><br>
              <span class="is-size-5" v-if="props.row.region">{{ props.row.region.title.display }}</span><br>
              <span class="has-text-primary">{{ getEmail(props.row) }}</span><br>
              <ws-demo-exams-certificate-view
                expertType="linealExpert"
                :exam_day_cm1="exam.day_cm1"
                :expert="props.row"
              />
              <b-checkbox
                name="remote"
                class="b-checkbox__centered"
                v-if="isRemoteExam"
                :disabled="isDisabledExpertsInRemote(props.row)"
                v-model="props.row.is_remote"
              >
                <b>{{$t('Дистанционный (удаленный) формат')}}</b>
                <ws-spinner v-if="isRemotePending(props.row)" />
              </b-checkbox>
            </span>
          </div>
          <div class="ws-member__column">
            <ws-role-node :except="['front_50plus', 'front_mio']">
              <div
                v-if="props.row.expert_exam_status === expertStatus.accepted"
                class="has-text-success has-text-weight-bold is-size-5"
                v-text="$t('Выбран')"
              ></div>
              <div
                v-else
                class="has-text-danger has-text-weight-bold is-size-5"
                v-text="$t('Не подтвержден ГЭ')"
              ></div>
            </ws-role-node>
          </div>
          <div
            class="ws-member__column"
            style="padding-right: 20px"
          >
            <div
              class="buttons"
              v-if="!isDisabledExpertsInRemote() && !props.row.local"
            >
              <ws-permission-node
                :resources="['services/de/experts']"
                :actions="['update']"
                effect="display"
              >
                <!-- TODO Разграничить права на добавдение/редактирование экспертов на бэке-->
                <ws-role-node :except="buttonsExcept">
                  <template v-if="props.row.expert_exam_status !== expertStatus.accepted && !isExpertHasAccess(props.row)">
                    <button
                      type="button"
                      disabled
                      class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                      v-text="$t('Назначение недоступно')"
                    ></button>
                  </template>
                  <template v-else>
                    <button
                      type="button"
                      class="ws-button button is-primary is-small is-uppercase is-fullwidth"
                      :class="{'is-loading':expertsStatusPending.indexOf(props.row.guid) > -1}"
                      @click="acceptExpert(props.row.guid, true)"
                      v-if="props.row.expert_exam_status !== expertStatus.accepted && isExpertHasAccess(props.row)"
                      v-text="$t('Назначить')"
                      :disabled="isActionsDisabled"
                    ></button>
                  </template>
                  <ws-role-node :except="['front_mio', 'front_50plus']">
                    <button
                      type="button"
                      class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                      :class="{'is-loading':expertsStatusPending.indexOf(props.row.guid) > -1}"
                      @click="acceptExpert(props.row.guid, false)"
                      v-if="props.row.expert_exam_status === expertStatus.accepted"
                      v-text="$t('Отменить')"
                      :disabled="isActionsDisabled"
                    ></button>
                  </ws-role-node>
                </ws-role-node>
              </ws-permission-node>
              <ws-permission-node
                :resources="['services/de/experts']"
                :actions="['delete']"
                effect="display"
              >
                <button
                  type="button"
                  :class="{'is-loading': isDeleteLoading}"
                  class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                  @click="deleteExpert(props.row.guid)"
                  v-text="$t('Удалить')"
                  :disabled="isDeleteDisabled"
                ></button>
              </ws-permission-node>
            </div>
          </div>
        </div>
        </ws-list-view-item-column>
      </template>
    </ws-list-view>
    <p v-else-if='showEmpty' class="has-text-grey">Эксперты не прикреплены</p>
  </div>
</template>

<script>
import WsDemoExamsCertificateView from '../demo-exams/WsDemoExamsCertificateView.vue'
import { constants } from '@/services/constants.service'
import expertStatus from '../demo-exams/data/expertStatusEnum'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import validateExpertCertificates from '@/utils/validate-expert-certificates'
import { get } from 'lodash'

export default {
  name: 'WsLinealExpertCardList',
  components: { WsDemoExamsCertificateView },
  props: {
    exam: {
      type: Object,
      default: () => ({})
    },
    expertsData: {
      type: Array,
      default: () => []
    },
    isDeleteLoading: {
      type: Boolean,
      default: false
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    },
    isPending: {
      type: Boolean,
      default: false
    },
    showEmpty: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expertsIsRemotePending: [],
      expertStatus,
      experts: []
    }
  },
  computed: {
    ...mapState('exams', ['expertsStatusPending']),
    ...mapState('authentication', ['currentRole']),
    ...mapState('examExtraRules', ['examRules']),
    isRemoteExam () {
      return this.exam.flags.indexOf('remote_experts') > -1
    },
    isDisableCheckDocs () {
      const examFlags = this.exam.flags || []
      const rulesFlags = [
        ...this.examRules.attestation_type,
        ...this.examRules.level_de
      ]

      const isDisableCheck = examFlags.every(flag => !rulesFlags.includes(flag))

      return isDisableCheck
    },
    buttonsExcept () {
      if (this.isDisableCheckDocs) {
        return ['front_rcc', 'front_curator_institution']
      }
      return ['front_rcc', 'front_curator', 'front_curator_institution']
    },
    isExamComplete () {
      return this.exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT ||
        this.exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT_BLOCKED
    },
    isActionsDisabled () {
      if (['front_admin'].includes(this.currentRole)) {
        return false
      }
      return !this.isMyDeCenter || this.isExamComplete || ['front_curator'].includes(this.currentRole)
    },
    isDeleteDisabled () {
      if (['front_admin', 'front_rcc'].includes(this.currentRole)) {
        return false
      }
      return !(this.currentRole === 'front_curator' && this.isMyDeCenter) || this.isExamComplete
    }
  },
  watch: {
    expertsData: {
      immediate: true,
      handler (data) {
        this.experts = data
      }
    }
  },
  methods: {
    ...mapActions('exams', ['update', 'updateExpertStatus']),
    isDisabledExpertsInRemote () {
      return (this.exam.status === constants.exam_status.APPROVED_MAIN_EXPERT && this.currentRole === 'front_me')
    },
    isRemotePending (expert) {
      return this.expertsIsRemotePending.indexOf(expert.guid) > -1
    },
    isExpertHasAccess (exp) {
      if (this.isDisableCheckDocs && ['front_curator', 'front_rcc'].includes(this.currentRole)) {
        return true
      }
      const isValidCertificate = validateExpertCertificates(exp.certificates, this.exam.ended_at)
      const isValidAttestation = validateExpertCertificates(exp.attestations, this.exam.ended_at)
      return isValidCertificate || isValidAttestation || ['front_admin', 'front_dep', 'front_me'].includes(this.currentRole)
    },
    isValidCertificate (exp) {
      const certificates = exp.certificates || []
      return certificates.some(i => moment(this.exam.ended_at).isBetween(i.issued_at, i.expired_at))
    },
    isValidAttestation (exp) {
      const attestations = exp.attestations || []
      return attestations.some(i => moment(this.exam.ended_at).isBetween(i.issued_at, i.expired_at))
    },
    async acceptExpert (guid, status) {
      const updatedExam = await this.updateExpertStatus([this.exam.guid, guid, status])
      const expert = updatedExam.experts.find(e => e.guid === guid)
      if (expert) {
        const examExpertIndex = this.exam.experts.findIndex(e => e.guid === guid)
        this.experts[examExpertIndex].expert_exam_status = expert.expert_exam_status
        this.$emit('updateExperts', this.experts)
      }
      return updatedExam
    },
    deleteExpert (guid) {
      this.$emit('onDeleteExpert', guid)
    },
    getExpertName (expert) {
      const key = expert.user_info ? 'user_info.' : ''
      const firstName = get(expert, `${key}first.display`, '')
      const lastName = get(expert, `${key}last.display`, '')
      const middleName = get(expert, `${key}middle.display`, '')
      const fullName = `${lastName} ${firstName} ${middleName}`
      return fullName.trim()
    },
    getEmail (expert) {
      const key = expert.user_info ? 'user_info.' : ''
      return get(expert, `${key}email`, '')
    }
  }
}
</script>

<style lang='scss' scoped>
.l-expert {
  &__loading {
    position: relative;
    min-height: 100px;
  }
}
</style>
